module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('div', {
    ref: "content",
    staticClass: "content"
  }, [_c('div', {
    staticClass: "fullpage-container hidden-sm-down"
  }, [_c('div', {
    directives: [{
      name: "fullpage",
      rawName: "v-fullpage",
      value: (_vm.opts),
      expression: "opts"
    }],
    ref: "fullpage",
    staticClass: "fullpage-wp"
  }, [_c('div', {
    staticClass: "page-1 page"
  }, [_c('div', {
    staticClass: "bg_wrapper"
  }, [_c('div', {
    staticClass: "polygon"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg_container",
    class: ['active' + _vm.visual]
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "slogan"
  }, [_c('div', {
    staticClass: "artwork_wrapper"
  }, [_c('div', {
    staticClass: "link_wrapper"
  }, [_c('router-link', {
    staticClass: "cockroach_1",
    attrs: {
      "to": "/product/cockroach"
    }
  }, [_c('span')]), _vm._v(" "), _c('a', {
    staticClass: "cockroach_2",
    on: {
      "click": function($event) {
        _vm.jumpToCockroach(1)
      }
    }
  }, [_c('span')]), _vm._v(" "), _c('a', {
    staticClass: "cockroach_gel",
    on: {
      "click": function($event) {
        _vm.jumpToCockroach(2)
      }
    }
  }, [_c('span')]), _vm._v(" "), _c('router-link', {
    staticClass: "ant_1",
    attrs: {
      "to": "/product/ant"
    }
  }, [_c('span')])], 1), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/home_slogan2.png")
    }
  })])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "visual_switch"
  }, [_c('div', {
    staticClass: "switch",
    class: {
      active: _vm.visual == 0
    },
    on: {
      "click": function($event) {
        _vm.changeImage(0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "switch",
    class: {
      active: _vm.visual == 1
    },
    on: {
      "click": function($event) {
        _vm.changeImage(1)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pageControl"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.scrollToProduct(1)
      }
    }
  }, [_c('span', {
    staticClass: "item item-half item-icon white"
  }, [_c('svg', {
    staticClass: "icon icon-arrow icon-rotate-down",
    attrs: {
      "id": "bottomArrow",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 60 60",
      "xml:space": "preserve",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('path', {
    staticClass: "icon-path",
    attrs: {
      "d": "M14.2,52.5c-1.8,1.8-1.8,4.7,0,6.5c1.8,1.8,4.6,1.8,6.4,0l25.3-25.8c1.8-1.8,1.8-4.7,0-6.5L20.6,1c-1.8-1.8-4.6-1.8-6.4,0c-1.8,1.8-1.8,4.7,0,6.5L34.9,30L14.2,52.5z"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  })]), _vm._v(" "), _c('div', {
    staticClass: "page-2 page"
  }, [_c('div', {
    staticClass: "pageControl"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.scrollToProduct(0)
      }
    }
  }, [_c('span', {
    staticClass: "item item-half item-icon white"
  }, [_c('svg', {
    staticClass: "icon icon-arrow icon-rotate-up",
    attrs: {
      "id": "bottomArrow",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 60 60",
      "xml:space": "preserve",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('path', {
    staticClass: "icon-path",
    attrs: {
      "d": "M14.2,52.5c-1.8,1.8-1.8,4.7,0,6.5c1.8,1.8,4.6,1.8,6.4,0l25.3-25.8c1.8-1.8,1.8-4.7,0-6.5L20.6,1c-1.8-1.8-4.6-1.8-6.4,0c-1.8,1.8-1.8,4.7,0,6.5L34.9,30L14.2,52.5z"
    }
  })])])])]), _vm._v(" "), _c('contact'), _vm._v(" "), _c('henkel-footer')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "mobile hidden-md-up"
  }, [_c('div', {
    staticClass: "bg_container",
    class: ['active' + _vm.visual]
  }, [_vm._m(3), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "cartoon_container"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "cartoon_main"
  }, [_c('div', {
    staticClass: "artwork_wrapper"
  }, [_c('div', {
    staticClass: "link_wrapper"
  }, [_c('a', {
    staticClass: "cockroach_2",
    on: {
      "click": function($event) {
        _vm.jumpToCockroach(1)
      }
    }
  }, [_c('span')]), _vm._v(" "), _c('router-link', {
    staticClass: "ant_1",
    attrs: {
      "to": "/product/ant"
    }
  }, [_c('span')]), _vm._v(" "), _c('router-link', {
    staticClass: "cockroach_1",
    attrs: {
      "to": "/product/cockroach"
    }
  }, [_c('span')])], 1), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/home_cartoon_main_2022.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cartoon"
  }, [_c('div', {
    staticClass: "artwork_wrapper"
  }, [_c('div', {
    staticClass: "link_wrapper"
  }, [_c('a', {
    staticClass: "cockroach_gel",
    on: {
      "click": function($event) {
        _vm.jumpToCockroach(2)
      }
    }
  }, [_c('span')])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/home_cartoon_m_2_2022.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cartoon__claimRef"
  }, [_vm._v("\n            *資料來源：Euromonitor Retail Value Comparison of Insecticide Baits Category in Hong Kong, Data 2014-2017, 2019-2021\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "visual_switch"
  }, [_c('div', {
    staticClass: "switch",
    class: {
      active: _vm.visual == 0
    },
    on: {
      "click": function($event) {
        _vm.changeImage(0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "switch",
    class: {
      active: _vm.visual == 1
    },
    on: {
      "click": function($event) {
        _vm.changeImage(1)
      }
    }
  })])]), _vm._v(" "), _c('div', [_c('contact')], 1), _vm._v(" "), _c('henkel-footer')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/home_bg.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg"
  }, [_c('img', {
    staticClass: "tagline",
    attrs: {
      "src": require("../assets/home_bg_2_tagline.jpg")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/home_bg_2.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "claim"
  }, [_c('div', {
    staticClass: "claimFef"
  }, [_vm._v("\n              *資料來源：Euromonitor Retail Value Comparison of Insecticide Baits Category in Hong Kong, Data 2014-2017, 2019-2021\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile_bg"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/home_bg_m.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile_bg"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/home_bg_2_m.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slogan"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/home_slogan_m.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e54bd0b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 231
// module chunks = 0